// Which writes are autoplay's own: a desktop demoted while offline drops these on reconnect (`releaseLiveSync`).
let depth = 0

export const asAutoplay =
	fn =>
	(...args) => {
		depth++
		try {
			return fn(...args)
		} finally {
			depth--
		}
	}

export const isAutoplayWrite = () => depth > 0
